import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';
import { FormattedMessage } from 'react-intl';
import { map } from 'ramda';

import ActionButton from 'components/ActionButton';
import DocumentHeaderRow from 'routes/Documents/components/DocumentHeaderRow';
import DocumentTitle from 'routes/Documents/components/DocumentTitle';

const documentTypes = [{ name: 'medication' }, { name: 'vitamin' }];

const CommonHeader = ({ localeId, infoText = '', editText = {}, editing, startEdit, mode = 'edit', deleteElement }) => (
  <DocumentHeaderRow>
    <Col xs={12} sm={7} md>
      {!editing && <DocumentTitle localeId={localeId.title} />}
      {editing && editing.documentType && <DocumentTitle localeId={localeId[editing.documentType]} />}
      {infoText && !editing && (
        <Row style={{ marginTop: '0.5em' }}>
          <Col xs sm={9}>
            <p className="bold">
              <FormattedMessage id={infoText} />
            </p>
          </Col>
        </Row>
      )}
      {editText && editing && editing.documentType && (
        <Row style={{ marginTop: '0.5em' }}>
          <Col xs sm={9}>
            <p className="bold">
              <FormattedMessage id={editText[editing.documentType]} />
            </p>
          </Col>
        </Row>
      )}
    </Col>
    {!editing && window.__ROLE__ !== 'DOCTOR' && (
      <Col xs={12} sm={5} md style={{ marginTop: '1rem' }}>
        {map(d => (
          <Row key={d.name} xs="center" end="sm">
            <Col xs={12} style={{ marginBottom: '1rem' }}>
              <ActionButton
                localeId={'medication.addNew.' + d.name}
                border
                long
                secondary
                onClick={e => {
                  startEdit(d.name);
                }}
              />
            </Col>
          </Row>
        ))(documentTypes)}
      </Col>
    )}
  </DocumentHeaderRow>
);

CommonHeader.propTypes = {
  localeId: PropTypes.object.isRequired,
  infoText: PropTypes.string,
  editText: PropTypes.object,
  startEdit: PropTypes.func.isRequired,
  mode: PropTypes.string,
  editing: PropTypes.object,
  deleteElement: PropTypes.element,
};

export default CommonHeader;
